/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetActivitySearchDataCheckSampleRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'
import {GetActivitySearchDataCheckSampleResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'


export const getActivitySearchDataCheckSample = (request:GetActivitySearchDataCheckSampleRequest, options?: CashRequestOptions) => post<GetActivitySearchDataCheckSampleRequest, GetActivitySearchDataCheckSampleResponse>("/2.0/cash/get-activity-search-data-check-sample", request, {...options, rejectOnError: true })